// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cart-login-note[data-v-454ce9fe]{font-size:15px;padding-top:30px}", ""]);
// Exports
module.exports = exports;
